import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { RouterModule } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { InviteComponent } from './invite.component';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        CheckboxModule,
        FormsModule,
        PasswordModule,
        RouterModule,
        ReactiveFormsModule,
        MessageModule,
        ToastModule,
        TranslateModule,
        DividerModule
    ],
    declarations: [
        InviteComponent
    ],
    exports: [
        InviteComponent
    ],
    providers: [PermissionsService,MessageService]


})
export class InviteModule { }
